import { post } from '@webapp-next/lib/request/webapp/http';

export default async function employeeAgreementGet({
  dpMetaOption = false,
  agreementId = 0,
  association = ['EmployeeSalaryOpunits'],
} = {}) {
  if (!agreementId) {
    throw new Error('agreementId is required.');
  }

  const options = {
    headers: {},
  };

  if (dpMetaOption === false) {
    options.headers['dp-meta-option'] = 'none';
  }

  const body = {
    search: [
      {
        field: 'Id',
        type: 'eq',
        data: agreementId,
      },
    ],
    assoc: association,
  };

  try {
    const { data } = await post(
      '/api/v1/resource/EmployeeAgreement/QUERY',
      body,
      options
    );

    return {
      success: true,
      message: '',
      data: data || [],
    };
  } catch (e) {
    const { code, message } = e?.response?.data?.error || {
      code: undefined,
      message: undefined,
    };

    if (code === 400) {
      return {
        success: false,
        message,
      };
    }

    throw e;
  }
}
